import { TextField } from '@braskai/ui-kit';
import { Controller } from 'react-hook-form';

import { SControlledTextField, SControlledTextFieldLabel } from './styled';
import { ControlledTextFieldProps } from './types';

export const ControlledTextField = ({
  label,
  className,
  control,
  disabled = false,
  extraSpace,
  fieldName,
  icon,
  inputTestId,
  minRows,
  multiline,
  notRequired = false,
  placeholder,
  style,
  validator,
  ...props
}: ControlledTextFieldProps) => {
  return (
    <SControlledTextField className={className} style={style}>
      {label && (
        <SControlledTextFieldLabel color="grey.700" variant="body-2-md">
          {label}
        </SControlledTextFieldLabel>
      )}
      <Controller
        name={fieldName}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            disabled={disabled}
            error={!!error}
            extraHeight={extraSpace}
            helperText={error?.message}
            inputTestId={inputTestId}
            minRows={minRows}
            multiline={multiline}
            placeholder={placeholder}
            startAdornment={icon}
            fullWidth
            {...props}
          />
        )}
        /* TODO: type needs to be corrected */
        rules={{
          minLength: notRequired ? 0 : 1,
          required: notRequired ? undefined : 'Field is required',
          validate: (value: string) => {
            if (!notRequired && !value.trim()) {
              return 'Field is required';
            }

            return validator && validator(value);
          },
        }}
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */
        control={control}
      />
    </SControlledTextField>
  );
};
